
export const ANACOLOR_USER = 'anacolor.user';
export const ANACOLOR_TOKEN = 'anacolor.token';
export const ANACOLOR_REFRESH = 'anacolor.refresh';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const LOGIN_BASE_URL = process.env.REACT_APP_LOGIN_BASE_URL;

export const QUOTE_REBATES_ENABLED = false;